<template>
  <div class="box aaaaa">
    <div class="bbbbb">
      <div class="search">
        <el-form label-width="120px" label-height="60px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="评价人昵称" prop="memberName">
                <el-input
                  v-model="queryInfo.condition.memberName"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单号" prop="orderNumber">
                <el-input
                  v-model="queryInfo.condition.orderNumber"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="评价日期">
                <el-date-picker
                  style="margin-left: 8px; width: 260px"
                  clear-icon="date"
                  v-model="dataRange"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  unlink-panels
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="评价类型">
                <el-select
                  v-model="queryInfo.condition.isGood"
                  placeholder="请选择"
                  @change="search"
                  clearable style="width: 100%;"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="好评" :value="1"></el-option>
                  <el-option label="差评" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否为匿名评价">
                <el-select
                  v-model="queryInfo.condition.isAnonymous"
                  placeholder="请选择"
                  @change="search"
                  clearable style="width: 100%;"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="是" :value="2"></el-option>
                  <el-option label="否" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="是否隐藏">
                <el-select
                  v-model="queryInfo.condition.isHide"
                  placeholder="请选择"
                  @change="search" style="width: 100%;"
                  clearable
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="是" :value="2"></el-option>
                  <el-option label="否" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6" style="display: flex; justify-content: flex-end">
              <el-button @click="reset" icon="el-icon-refresh-left"
              >重置
              </el-button
              >
              <el-button type="primary" @click="search" icon="el-icon-search"
              >搜索
              </el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 表格部分 -->
      <div class="tab">
        <el-table
          :data="tableData"
          style="width: 100%"
          height="calc(100vh - 350px)"
          border
        >
          <el-table-column
            label="序号"
            type="index"
            width="50"
            align="center"
          ></el-table-column>

          <!--        <el-table-column-->
          <!--          prop="id"-->
          <!--          label="id"-->
          <!--          align="center"-->
          <!--          show-overflow-tooltip-->
          <!--          width="200px"-->
          <!--        >-->
          <!--          <template slot-scope="scope">{{ scope.row.id }}</template>-->
          <!--        </el-table-column>-->
          <el-table-column
            prop="memberName"
            label="评价人昵称"
            align="center"
            show-overflow-tooltip
            width="200px"
          >
            <template slot-scope="scope">{{
                scope.row.isAnonymous == 1 ? scope.row.memberName : "匿名评价"
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="memberUrl"
            label="评价人头像"
            align="center"
            width="150px"
          >
            <template slot-scope="scope">
              <img
                v-if="scope.row.isAnonymous == 1"
                style="height: 50px; width: 50px"
                :src="scope.row.memberUrl"
                alt=""
              />
              <img
                v-else
                style="height: 50px; width: 50px"
                src="https://stjnfile.duochicai.com/resources/upload/dcc/tx.png"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="isAnonymous"
            width="150"
            label="是否为匿名评价"
            align="center"
          >
            <template slot-scope="scope">
              <el-button slot="reference" type="text">{{
                  scope.row.isAnonymous == 1 ? "否" : "是"
                }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="orderNumber"
            label="订单号"
            align="center"
            show-overflow-tooltip
            width="200px"
          >
            <template slot-scope="scope">{{ scope.row.orderNumber }}</template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="评价时间"
            align="center"
            show-overflow-tooltip
            width="200px"
          >
            <template slot-scope="scope">{{ scope.row.createTime }}</template>
          </el-table-column>
          <el-table-column
            prop="productName"
            label="订单信息"
            align="center"
            show-overflow-tooltip
            width="200"
          >
            <template slot-scope="scope">{{ scope.row.productName }}</template>
          </el-table-column>
          <el-table-column
            prop="commentProductLevel"
            label="商品评分"
            align="center"
            min-width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-rate
                v-model="scope.row.commentProductLevel"
                :max="5"
                :disabled="true"
                :show-text="false"
                :show-score="false"
              ></el-rate>
            </template>
          </el-table-column>
          <!--        <el-table-column-->
          <!--          prop="commentTeamlevel"-->
          <!--          label="团长评分"-->
          <!--          align="center"-->
          <!--          min-width="150"-->
          <!--          show-overflow-tooltip-->
          <!--        >-->
          <!--          <template slot-scope="scope">-->
          <!--            <el-rate-->
          <!--              v-model="scope.row.commentTeamlevel"-->
          <!--              :max="5"-->
          <!--              :disabled="true"-->
          <!--              :show-text="false"-->
          <!--              :show-score="false"-->
          <!--            ></el-rate>-->
          <!--          </template>-->
          <!--        </el-table-column>-->

          <el-table-column
            prop="commentContent"
            label="评价内容"
            align="center"
            show-overflow-tooltip
            width="200px"
          >
            <template slot-scope="scope">{{ scope.row.commentContent }}</template>
          </el-table-column>
          <el-table-column
            prop="commentImgs"
            label="评价图片"
            align="center"
            width="300"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.commentImgs">
                <el-image
                  v-for="(imgUrl, index) in parseImgs(scope.row.commentImgs)"
                  :key="index"
                  style="width: 50px; height: 50px; margin-right: 5px"
                  :src="imgUrl"
                  :preview-src-list="parseImgs(scope.row.commentImgs)"
                  lazy
                >
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="操作"
            width="240"
            fixed="right"
            align="center"
          >
            <template slot-scope="scope">
              <el-row type="flex" justify="start">
                <el-button type="text" @click="deta(scope.row.id)"
                >详情
                </el-button
                >
                <el-button
                  type="text"
                  @click="edit(scope.row)"
                  size="small"
                >编辑
                </el-button
                >
                <el-button
                  type="text"
                  @click="hide(scope.row)"
                  size="small"
                  v-if="scope.row.isHide == 1"
                >隐藏
                </el-button
                >
                <el-button
                  type="text"
                  @click="hide(scope.row)"
                  size="small"
                  v-else
                >开放
                </el-button
                >
                <el-popconfirm
                  title="确定删除吗？"
                  @confirm="handleDelte(scope.row.id)"
                >
                  <el-button type="text" slot="reference" style="color: red;margin-left: 10px;">删除</el-button>
                </el-popconfirm>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryInfo.currPage"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>

    </div>
    <el-dialog :visible.sync="showDialog" title="评价详情" width="800px">
      <div class="review-details">
        <div class="user-info">
          <img :src="detail.memberUrl" alt="用户头像" class="user-avatar"/>
          <div>
            <span class="username">{{ detail.memberName }}</span> 评价时间 :
            <span class="review-time">{{ detail.createTime }}</span>
          </div>
        </div>
        <div class="product-info">
          商品信息 :
          <span>{{ detail.productName }}</span>
        </div>
        <div class="review-content">
          评价内容 :
          <span>{{ detail.commentContent }}</span>
        </div>
        <div class="review-images" v-if="imgs.length > 0">
          <el-image
            v-if="imgUrl"
            v-for="(imgUrl, index) in imgs"
            :key="index"
            style="width: 100px; height: 100px; margin: 5px"
            :src="imgUrl"
            :preview-src-list="imgs"
            lazy
          >
          </el-image>
        </div>
        <div class="rating">
          <span>商品评分：</span>
          <el-rate v-model="detail.commentProductLevel" disabled></el-rate>
        </div>
        <!--        <div class="rating">-->
        <!--          <span>团长评分：</span>-->
        <!--          <el-rate v-model="detail.commentTeamlevel" disabled></el-rate>-->
        <!--        </div>-->
        <el-timeline>
          <el-timeline-item
            v-for="(reply, index) in detail.replyList"
            :key="index"
          >
            <div class="reply-content">
              <strong v-if="reply.replierType === '1'">商家回复</strong>
              <strong v-else-if="reply.replierType === '2'">买家回复</strong>
              <p>{{ reply.commentReplyContent }}</p>
              <span class="reply-time">{{ reply.createTime }}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
        <div class="reply-input">
          <el-input
            type="textarea"
            placeholder="请输入您的回复"
            v-model="newReply"
          ></el-input>
          <el-button style="margin-bottom: -8%" type="primary" @click="addReply">提交回复</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="editDialog" title="修改评价" width="800px">
      <el-form :model="obj" label-width="100px">
        <el-form-item label="评分">
          <el-rate
            v-model="obj.commentProductLevel"
            :max="5"
            :show-text="false"
            :show-score="false"
          ></el-rate>
        </el-form-item>

        <el-form-item label="评论内容">
          <el-input type="text" v-model="obj.commentContent"></el-input>
        </el-form-item>

        <el-form-item label="评论图片">
          <upLoadList @addImgList="addImgList" @delImgList="delImgList" :list="obj.imgs"
                      :preview-img-list="obj.imgs"></upLoadList>
        </el-form-item>
        <!--         handelVideo-->
        <el-form-item label="评论视频">
          <el-upload
            class="avatar-uploader xin"
            action="https://stjnapi.duochicai.com/api/upload/uploadVideo"
            :show-file-list="false"
            :on-success="handelVideo"
            :before-upload="beforeAvatarUploadVideo"
            :on-progress="onProgress"
            v-loading="loading"
          >
            <div v-if="obj.commentVideos" class="flex">
              <div
                class="imgBox"
                v-for="(item, index) in obj.commentVideos"
                :key="index"

              >
                <img :src="item.imgUrl" class="avatar" alt=""/>
                <div class="img-icon">
                  <i
                    class="el-icon-zoom-in"
                    @click.stop="onPreview(item)"
                  ></i>
                  <i class="el-icon-delete" @click.stop="handelRemove(index)"></i>
                </div>
              </div>
            </div>
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-row type="flex" justify="center">
          <el-button style="width: 100px; height: 40px;" type="primary" @click="editSave">确定</el-button>
          <el-button style="width: 100px; height: 40px;" @click="editDialog = false">取消</el-button>
        </el-row>

      </el-form>
    </el-dialog>

    <el-dialog title="视频" :visible.sync="dialogVisibleVideo" width="50%">
      <video
        width="100%"
        header="500px"
        :src="dialogVideoUrl"
        alt=""
        controls
      />
    </el-dialog>

  </div>
</template>

<script>
import upLoadList from '@/components/upLoadList.vue'

export default {
  components: {
    upLoadList
  },
  data () {
    return {
      imgs: [],
      height: window.innerHeight - 256, // 表格高度
      newReply: '',
      dataRange: '',
      detail: {},
      replyList: [],
      reverse: true,
      form: {},
      rules: {},
      total: 0,
      addressList: [],
      valuechange1: [],
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      showDialog: false,
      tableData: [],
      headerHeight: 0,
      editDialog: false,
      obj: {},
      loading: false,
      dialogVisibleVideo: false,
      dialogVideoUrl: ''
    }
  },
  created () {
    this.getList()
  },

  mounted () {
  },
  methods: {

    addImgList (text, url) {
      this.obj.imgs.push(url)
    },
    delImgList (text, url) {
      const index = this.obj.imgs.findIndex(item => item === url)
      console.log(index, 508)
      this.obj.imgs.splice(index, 1)
    },

    handelRemove (index) {
      this.obj.commentVideos.splice(index, 1)
    },
    onProgress () {
      this.loading = true
    },

    handelVideo (response) {
      console.log(response, 486)
      this.loading = false
      this.obj.commentVideos.push({
        url: response.data.videoUrl,
        imgUrl: response.data.imgUrl
      })
      console.log(this.obj.commentVideos, 492)
    },
    beforeAvatarUploadVideo (file) {
      console.log(file.type, 'video')
      const VideoType =
        file.type === 'video/mp4' ||
        file.type === 'video/avi' ||
        file.type === 'video/wmv' ||
        file.type === 'video/rmvb'

      if (!VideoType) {
        this.$message.error('上传视频只能是 MP4 、AVI 、WMV 、RMVB 格式!')
      }
      return VideoType
    },

    onPreview (item) {
      this.dialogVideoUrl = item.url
      this.dialogVisibleVideo = true
    },

    async editSave () {
      this.obj.commentImgs = this.obj.imgs.join(',')

      const res = await this.$http.post('comment/update', this.obj)

      if (res.data.code == 200) {
        this.getList()
        this.editDialog = false
        this.$message.success('修改成功')
      }
    },

    async deta (id) {
      var that = this
      that.showDialog = true

      const response = await that.$http.post('/comment/queryCommentDetail', {
        id: id
      })
      console.log(response.data.data)
      if (response.data.code == 200) {
        that.detail = response.data.data
        that.imgs = that.parseImgs(this.detail.commentImgs)
      }
    },

    async edit (row) {
      this.editDialog = true
      const res = await this.$http.post('comment/queryOne', {
        commentCode: row.commentCode
      })
      if (res.data.code === 200) {
        res.data.data.imgs = res.data.data.commentImgs ? res.data.data.commentImgs.split(',') : []
        res.data.data.commentVideos = JSON.parse(res.data.data.commentVideos)
        this.obj = res.data.data
      } else {
        this.$message.error(res.data.message)
      }
    },

    // 获取数据
    getList () {
      this.height = window.innerHeight - this.headerHeight - 256
      var that = this
      let data = JSON.parse(JSON.stringify(this.queryInfo))
      if (
        this.dataRange != '' &&
        this.dataRange != null &&
        this.dataRange.length != 0
      ) {
        data.condition.startTime = this.dataRange[0] + ' 00:00:00'
        data.condition.endTime = this.dataRange[1] + ' 23:59:59'
      }
      data.condition.hideFlag = '1'
      that.$http.post('/comment/list', data).then(function (response) {
        console.log(response.data.data)
        if (response.data.code == 200) {
          that.total = response.data.data.count
          that.queryInfo.currPage = response.data.data.currPage
          that.tableData = response.data.data.data
          that.addressList = response.data.data.data
        }
      })
    },
    addReply () {
      var that = this
      if (this.newReply.trim() === '') return
      // console.log(66666, this.detail.commentCode);
      // 创建新的回复对象，并使用 ISO 8601 格式的时间字符串
      const newReplyObj = {
        replierType: '1', // 这里可以根据实际情况判断是买家还是卖家
        commentReplyContent: this.newReply,
        createTime: new Date().toISOString(), // 使用 ISO 8601 格式
        comentCode: this.detail.commentCode
      }

      // 发送请求到后端
      that.$http
        .post('/commentReply/save', newReplyObj)
        .then((response) => {
          // 处理响应
          if (response.data.code === 200) {
            // 如果成功，将新回复添加到列表中
            that.replyList.push(newReplyObj)
            that.$message.success('回复成功')
            // 清空输入框
            that.newReply = ''
            // 关闭弹窗并刷新列表页
            that.showDialog = false // 确保这里使用了正确的变量名
            that.search()
            // that.refreshList();
            // // 可能还需要重新获取评论详情，以更新服务器上的数据
            // that.fetchReviewDetail(that.reviewId);
          } else {
            // 处理错误情况
            console.error('提交回复失败:', response.data.message)
          }
        })
        .catch((error) => {
          // 处理错误
          console.error('提交回复请求失败:', error)
        })
    },
    search () {
      this.queryInfo.currPage = 1
      this.getList()
    },
    reset () {
      this.queryInfo.condition = {
        dataRange: '',
        name: '',
        phone: '',
        storeName: '',
        extent: '',
        openTime: '',
        applyReason: ''
      }
      this.address = '';
      (this.selectedOptions = []), (this.queryInfo.currPage = 1)
      this.getList()
    },
    handleClose (done) {
      // 如果需要在关闭前执行某些操作，可以在这里添加逻辑
      done()
    },
    // 隐藏
    hide (row) {
      // this.tableData = this.tableData.filter((item) => item.id !== row.id);

      this.$http
        .post('/comment/update', {
          id: row.id,
          isHide: row.isHide == 1 ? 2 : 1
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.getList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'fail'
            })
          }
        })
    },

    // 删除用户
    async handleDelte (id) {
      const confirmResult = await this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        var that = this
        that.$http
          .post('/comment/deleteNew', { id: id })
          .then(function (response) {
            if (response.data.code == 200) {
              that.$notify.success({
                title: '提示',
                message: '删除成功',
                showClose: true
              })
              that.search()
            } else {
              that.$notify.info({
                title: '提示',
                message: response.data.message,
                showClose: true
              })
            }
          })
      }
    },
    parseImgs (imgs) {
      // 将图片URL字符串按照逗号分隔成数组
      return imgs?.split(',')?.map((img) => img.trim())
    },
    orderStatusChange () {
    },
    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.getList()
    },
    change1 () {
      console.log(this.valuechange1)
      if (this.valuechange1) {
        this.queryInfo.condition.startTime1 = this.newDate(
          this.valuechange1[0]
        )
        this.queryInfo.condition.endTime1 = this.newDate(this.valuechange1[1])
      } else {
        this.valuechange1 = []
        this.queryInfo.condition.startTime1 = ''
        this.queryInfo.condition.endTime1 = ''
      }
    },
    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val
      this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
.view-box {
  flex: 1;
  /* height: 540px; */
  min-height: 540px;
  max-height: calc(85vh - 180px);
  overflow-y: auto;

  .imgli {
    flex: 1;

    img {
      width: 100%;
      object-fit: contain;
    }
  }
}

.el-tabs__header {
  margin: 0;
}

.box {
  .search {
    background-color: #fff;
    box-sizing: border-box;
    padding: 15px 15px;

    .search-top {
      padding: 5px;
      background-color: rgba(30, 152, 215, 0.14);
      font-size: 15px;
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      div {
        width: 150px;
        text-align: center;
      }
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 140px;
    height: 140px;
    line-height: 140px;
    text-align: center;
  }

  .avatar {
    width: 140px;
    height: 140px;
    display: block;
  }

  .tab {
    background-color: #fff;
    // margin-top: 15px;
    padding: 15px;
  }

  .review-details {
    font-size: 14px;
  }

  .user-info {
    display: flex;
    align-items: center;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .username {
    font-weight: bold;
  }

  .review-time {
    color: #999;
  }

  .product-info,
  .review-content,
  .merchant-reply,
  .buyer-reply {
    margin-top: 10px;
  }

  .review-images {
    display: flex;
    margin-top: 10px;
  }

  .review-image {
    width: 60px;
    height: 60px;
    margin-right: 10px;
  }

  .rating {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  .rating-text {
    margin-left: 5px;
  }

  .merchant-reply,
  .buyer-reply {
    border-top: 1px solid #eee;
    padding-top: 10px;
  }

  .dialog-footer {
    text-align: right;
  }

  .reply-input {
    display: grid;
    place-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.el-button {
  padding: 0 8px;
}

.el-dialog__body {
  padding: 0 !important;
}

::v-deep .el-dialog__body {
  padding-top: 0 !important;
}

.imgss {
  margin: 5px;
}

.bigImg {
  width: 500px;
}

.fixed {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  padding-top: 20px;
  box-sizing: border-box;
  background-color: #fff;
  z-index: 2;
}

.container {
  padding: 5px;
  box-sizing: border-box;

  .box {
    width: 100%;

    background-color: #fff;
    font-size: 14px;
    border-radius: 5px;
    color: #333;

    .title {
      border-bottom: 1px solid #eee;
      padding: 10px;
      box-sizing: border-box;

      &::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 20px;
        margin-right: 15px;
        background-color: #02a7f0;
        // 和标题对其
        vertical-align: middle;
      }
    }

    .content2 {
      padding: 0px 20px 20px 20px;
      box-sizing: border-box;
    }

    .content {
      padding: 0px 20px;
      box-sizing: border-box;

      .imgTitle {
        margin-top: 10px;
        box-sizing: border-box;
        font-weight: 700;
        padding-bottom: 10px;
        box-sizing: border-box;
        border-bottom: 1px solid #eee;
      }

      .imgbox {
        padding: 10px;
        box-sizing: border-box;
      }

      .fa {
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding-left: 15px;
        box-sizing: border-box;
        background-color: #e3f5fd;
        margin: 10px;
      }
    }
  }
}

.mp {
  margin-top: 15px;
}

.mp10 {
  margin-top: 10px;
}

.pd50 {
  padding: 0 50px;
  box-sizing: border-box;
}

.left10 {
  padding-left: 20px;
  box-sizing: border-box;
}

.tp5 {
  margin-top: 5px;
  width: 140px;
  text-align: center;
  font-weight: 700;
  color: #8c939d;
}

.imgs {
  width: 140px;
  height: 140px;
  margin: 5px;
}

.center {
  width: 600px;
  text-align: center;
  margin: 10px auto;
}

.lable {
  width: 140px;
  display: inline-block;
  text-align: end;
}

.imgBox {
  //width: 140px;
  height: 140px;
  position: relative;
  //margin-bottom: 5px;
}

.imgBox:hover .img-icon {
  display: flex;
}

.imgBox:hover .img-icon {
  display: flex;
}

.img-icon {
  width: 140px;
  height: 140px;
  border-radius: 6px;
  position: absolute;
  left: 0;
  top: 0;
  display: none;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: rgba(0, 0, 0, 0.4);

  i {
    font-size: 26px;
    color: #fff;
  }
}

.avatar-uploader {
  // min-width: 200px;
}

.avatar-uploader ::v-deep .el-upload {
  //background-color: #fbfdff;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  //gap: 10px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 140px;
  line-height: 140px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}

/deep/ .el-loading-spinner {
  margin-top: -74px;
}

.avatar {
  display: block;
  width: 140px;
  height: 140px;
  border-radius: 6px;
}

.imgBox {
  //width: 140px;
  height: 140px;
  position: relative;
  //margin-bottom: 5px;
}

.imgBox:hover .img-icon {
  display: flex;
}

.table {
  .el-button {
    height: 20px !important;
    line-height: 6px !important;
  }
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f59a23 !important;
}

.text {
  text-align: center;
  margin-top: 10px;
}

::v-deep .el-table td {
  padding: 0 !important;
}

::v-deep .el-table th {
  padding: 0px !important;
}

.pdfbox {
  display: flex;

  .item {
    margin: 0 10px;
  }
}

.imgboxs {
  margin-left: 140px;
  margin-top: 5px;
  display: flex;

  & > div {
    margin: 0 10px;
  }
}

::v-deep .el-image {
  margin: 5px !important;
}

// .titlesss::before {
//   content: "*";
//   color: red;
//   position: absolute;
//   left: 2px;
// }
.titlesss {
  color: red;
  display: inline-block;
  margin-right: 3px;
}

.success {
  color: #62a003;
  font-weight: 700;
}

.error {
  color: #d6000a;
  font-weight: 700;
}

.shenhebox {
  height: 500px;
  overflow: auto;
}

.tag {
  width: 80px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  text-align: center;
}

.img-icon {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: absolute;
  left: 0;
  top: 0;
  display: none;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: rgba(0, 0, 0, 0.4);

  i {
    font-size: 26px;
    color: #fff;
  }
}

.imgBox {
  //width: 148px;
  height: 148px;
  height: 148px;
  position: relative;
  //margin-bottom: 5px;
}

.imgBox:hover .img-icon {
  display: flex;
}

.imgBox:hover .img-icon {
  display: flex;
}

::v-deep .avatar-uploader .el-upload {
  border: none;
}

::v-deep .el-table thead {
  height: 40px !important;
}
</style>
